export const AUTH_TOKEN :string = 'auth-token';
export const DATE_TIME_FORMAT: string = 'MM/DD/YYYY HH:mm:ss';
export const DATE_FORMAT: string = 'MM/DD/YYYY';
export const POLL_INTERVAL = 5000;
